import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "../../FormFields/DatePicker";

const MessageA22 = (props) => {
  const [dateSelect, setDateSelect] = useState({});
  const [errors, setErrors] = useState({});

  const initialDate1 = props.userInputObj && props.userInputObj.key1;
  const initialDate2 = props.userInputObj && props.userInputObj.key2;

  useEffect(() => {
    localStorage.setItem("inputValue", JSON.stringify({ key1: "", key2: "", isValid: false }));
    window.dispatchEvent(new Event("a15InputChange"));
  }, []);

  useEffect(() => {
    if (dateSelect.key1 && dateSelect.key2) {
      props?.inputValue?.current?.removeAttribute("disabled");
    }
  }, [dateSelect]);

  const textData = props.item && props.item.text_data;
  const dateData1 = textData && textData.date1;
  const dateData2 = textData && textData.date2;
  const errorFlag = textData && textData.errorFlag;
  const calenderDisableMessage = textData && textData.calenderDisableMessage;

  const parentCallback = (data, type) => {
    setDateSelect((prev) => {
      const updated = { ...prev, [type]: data };
      const bothSelected = updated.key1 && updated.key2;
      var existing = localStorage.getItem("inputValue");
      existing = existing ? JSON.parse(existing) : {};
      existing[type] = data;
      existing.isValid = !!bothSelected;
      localStorage.setItem("inputValue", JSON.stringify(existing));
      window.dispatchEvent(new Event("a15InputChange"));
      return updated;
    });
    setErrors((prev) => ({ ...prev, [type]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!dateSelect.key1) newErrors.key1 = dateData1?.error || "Please select a date!";
    if (!dateSelect.key2) newErrors.key2 = dateData2?.error || "Please select a date!";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div className="a22-date-container">
      <div className="a22-date-row">
        <div className="a22-date-col">
          <DatePicker
            {...props}
            message={dateData1?.title || "Start Date"}
            parentCallback={parentCallback}
            type="key1"
            dateData={dateData1}
            initialDate={initialDate1}
            parent={"A22"}
            noDefault={true}
          />
          {errors.key1 && <span className="a22-field-error">{errors.key1}</span>}
        </div>
        <div className="a22-date-col">
          <DatePicker
            {...props}
            message={dateData2?.title || "End Date"}
            parentCallback={parentCallback}
            type="key2"
            dateData={dateData2}
            initialDate={initialDate2}
            parent={"A22"}
            noDefault={true}
          />
          {errors.key2 && <span className="a22-field-error">{errors.key2}</span>}
        </div>
      </div>
      {(errorFlag || calenderDisableMessage) && (
        <div className="a22-info-banner">
          {errorFlag && <p className="a22-error-text">{errorFlag}</p>}
          {calenderDisableMessage && (
            <p className="a22-disable-text">{calenderDisableMessage}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default MessageA22;
